import {
   RECEIVE_ARTWORK,
   SET_SELECTED_ARTWORK,
   RESET_SELECTED_ARTWORK,
   SET_ARTWORK_FOR_MODAL
} from '../constants/artwork-constants'

// add artwork to the global store (regardless of journey id)
export const receiveArtwork = (artwork) => {
   return dispatch => {
      dispatch({
         type: RECEIVE_ARTWORK,
         payload: {
            data: artwork,
            receivedAt: Date.now()
         }
      })
   }
}

// add artwork to the global store (regardless of journey id)
export const setArtworkForModal = (galleryId, artworkId) => {
   return dispatch => {
      dispatch({
         type: SET_ARTWORK_FOR_MODAL,
         payload: {
            galleryId,
            artworkId,
            receivedAt: Date.now()
         }
      })
   }
}

// should this also update the navigation?
export const setSelectedArtwork = (galleryId, artworkId, journeyStep) => {
   return dispatch => {
      dispatch({
         type: SET_SELECTED_ARTWORK,
         payload: {
            galleryId,
            artworkId,
            journeyStep,
         }
      })
   }
}

// reset selected artwork back to an empty list
export const resetSelectedArtwork = (galleryId) => {
  return dispatch => {
    dispatch({
      type: RESET_SELECTED_ARTWORK,
      payload: {galleryId}
    })
  }
}


// WEBPACK FOOTER //
// ./src/actions/artwork-actions.js